import React, { useEffect, useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

const MobRegionToggle = ({
  dubaiUrl = "https://www.99gift.ae/",
  indiaUrl = "https://www.99gift.in/",
}) => {
  // Current website ke domain ke according region detect karo
  const getCurrentRegion = () => {
    if (typeof window === "undefined") {
      return "IND";
    }

    return window.location.hostname.endsWith("99gift.ae")
      ? "AE"
      : "IND";
  };

  const [region, setRegion] = useState(getCurrentRegion);

  // Browser Back / Forward par region update hoga
  useEffect(() => {
    const handlePageShow = () => {
      setRegion(getCurrentRegion());
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const handleRegionChange = (event) => {
    const selectedRegion = event.target.value;

    setRegion(selectedRegion);

    const url =
      selectedRegion === "UAE"
        ? dubaiUrl
        : indiaUrl;

    window.location.href = url;
  };

  return (
    <Box>
      <Select
        value={region}
        onChange={handleRegionChange}
        size="small"
        variant="outlined"
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              ml: 1,
              borderRadius: "8px",
              minWidth: 90,
            },
          },
        }}
        sx={{
          minWidth: 68,
          height: 30,
          borderRadius: "7px",
          backgroundColor: "#fff",

          "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #E5E7EB",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D1D5DB",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D1D5DB",
          },

          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: "5px",
            padding: "4px 6px",
            fontSize: "11px",
            fontWeight: 600,
          },

          "& .MuiSelect-icon": {
            fontSize: "16px",
            right: "3px",
          },
        }}
      >
        {/* UAE / Dubai */}
        <MenuItem
          value="UAE"
          sx={{
            minHeight: "32px",
            padding: "5px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <Box
              component="img"
              src="https://flagcdn.com/w40/ae.png"
              alt="UAE"
              sx={{
                width: 20,
                height: 13,
                objectFit: "cover",
                borderRadius: "2px",
              }}
            />

            <Typography
              sx={{
                fontFamily: "Be Vietnam Pro",
                fontSize: "11px",
                fontWeight: 600,
                color: "#2B3445",
              }}
            >
              UAE
            </Typography>
          </Box>
        </MenuItem>

        {/* India */}
        <MenuItem
          value="IND"
          sx={{
            minHeight: "32px",
            padding: "5px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <Box
              component="img"
              src="https://flagcdn.com/w40/in.png"
              alt="India"
              sx={{
                width: 20,
                height: 13,
                objectFit: "cover",
                borderRadius: "2px",
              }}
            />

            <Typography
              sx={{
                fontFamily: "Be Vietnam Pro",
                fontSize: "11px",
                fontWeight: 600,
                color: "#2B3445",
              }}
            >
              IND
            </Typography>
          </Box>
        </MenuItem>
      </Select>
    </Box>
  );
};

export default MobRegionToggle;
